import { z } from 'zod';
import { RsiInputSchema } from './rsi.schema';
import { MaInputSchema } from './ma.schema';
import { VwapInputSchema } from './vwap.schema';
import { MacdInputSchema } from './macd.schema';
import { OrderBlocksInputSchema } from './order-blocks.schema';
import { ZigZagInputSchema } from './zig-zag.schema';
import { MasterPatternInputSchema } from './master-pattern.schema';
import { MarketStructureInputSchema } from './market-structure.schema';
import { LiquidationInputSchema } from './liquidation.schema';

// Re-export all indicator input types
export * from './rsi.schema';
export * from './ma.schema';
export * from './vwap.schema';
export * from './macd.schema';
export * from './order-blocks.schema';
export * from './zig-zag.schema';
export * from './master-pattern.schema';
export * from './market-structure.schema';
export * from './liquidation.schema';

// Union Type
export const IndicatorConfigInputSchema = z.discriminatedUnion('type', [
  RsiInputSchema,
  MaInputSchema,
  VwapInputSchema,
  MacdInputSchema,
  OrderBlocksInputSchema,
  ZigZagInputSchema,
  MasterPatternInputSchema,
  MarketStructureInputSchema,
  LiquidationInputSchema
]);

export type IndicatorConfigInput = z.infer<typeof IndicatorConfigInputSchema>;
